import React, { useState, Fragment, useEffect, useRef } from "react";
import Select from "react-select";
import Firebase from "../../firebasehelper";
import NoteItem from "../../components/NoteItem";
import { getStringfromSeconds } from "../../functions";
import HexHover from "../../components/HexHover";

export default function SuperTicketDetailModal({
  ticket,
  brandData,
  onClickAttachment,
}) {
  const [selectedTicketType, setSelectedTicketType] = useState(null);
  const [taskers, setTaskers] = useState([]);
  const [selectedTasker, setSelectedTasker] = useState(null);

  const closeButtonRef = useRef();

  const HexButton = HexHover("button", brandData.hex);
  const ticketTypes = [
    { value: "Account management", label: "Account management" },
    { value: "Bugs", label: "Bugs" },
    { value: "Community management", label: "Community management" },
    { value: "Feature Request", label: "Feature Request" },
    { value: "Plans and pricing", label: "Plans and pricing" },
    { value: "Technical support", label: "Technical support" },
  ];

  const getTaskers = (brandData) => {
    Firebase.getTaskersByBrandID(brandData, (res) => {
      setTaskers(res);
    });
  };

  useEffect(() => {
    setSelectedTicketType({
      label: ticket.type,
      value: ticket.type,
    });
    getTaskers(brandData);
  }, [ticket]);

  const handleSelectTicketType = async (newTicketType) => {
    try {
      await Firebase.updateSuperTicketType(
        ticket.brand_id,
        ticket.id,
        newTicketType.value
      );
      setSelectedTicketType(newTicketType);
    } catch (err) {
      console.log("handleSelectTicketType() error", err);
    }
  };

  const handleSelectTasker = (tasker) => {
    setSelectedTasker(tasker);
  };

  const closeModal = () => {
    closeButtonRef.current.click();
  };

  return (
    <div
      className="modal fade modal-container"
      id="super_ticket_detail"
      tabIndex="1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Super Ticket Detail</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={closeButtonRef}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body pb-1"
            style={{ height: 570, fontSize: 12, overflowY: "auto" }}
          >
            {ticket && (
              <div className="ticket-container" id="containerElement">
                <div className="ticket-detail-brand">
                  <div className="ticket-detail-profile">
                    {brandData && (
                      <img
                        className="ticket-detail-brand-logo"
                        src={brandData.logo}
                        alt="ticket brand"
                      />
                    )}
                    <h3 className="ticket-detail-membername">
                      {brandData.name}
                    </h3>
                  </div>
                </div>
                <p>Date Created: {getStringfromSeconds(ticket.time)}</p>
                <p>Ticket Number: {ticket.id}</p>
                <p>
                  {`Ticket opened by ${
                    ticket.openedBy ? "User" : "Brand"
                  } ID: `}
                  {ticket.openedBy ? ticket.openedBy : brandData.id}
                </p>
                <div className="note-select-container">
                  <p>Ticket Type:</p>
                  <Select
                    placeholder="Select Ticket Type"
                    className="select"
                    classNamePrefix="note-select"
                    value={selectedTicketType}
                    onChange={handleSelectTicketType}
                    options={[
                      ...ticketTypes.map((type) => ({
                        value: type.value,
                        label: type.label,
                      })),
                    ]}
                  />
                </div>
                <div
                  className="note-select-container"
                  title="Temporarily unavailable"
                >
                  <p>Tasker</p>
                  <Select
                    isDisabled={true}
                    placeholder="Allocate a tasker"
                    className="select"
                    classNamePrefix="note-select"
                    value={selectedTasker}
                    onChange={handleSelectTasker}
                    options={taskers.map((tasker) => ({
                      value: tasker,
                      label: tasker.firstName,
                    }))}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: 20,
                    marginTop: 34,
                  }}
                >
                  <HexButton
                    className="btn btn-light text-dark"
                    data-toggle="modal"
                    data-target="#add_note_dialog"
                    onClick={closeModal}
                  >
                    Add note
                  </HexButton>
                </div>
                <Fragment>
                  <h4 style={{ marginBottom: 0 }}>Notes</h4>
                  {ticket.notes ? (
                    <div style={{ height: 200 }}>
                      {ticket.notes
                        .sort((a, b) => b.time - a.time)
                        .map((item, index) => (
                          <NoteItem
                            key={index}
                            note={item}
                            onClickAttachment={onClickAttachment}
                          />
                        ))}
                    </div>
                  ) : (
                    <p className="w-full text-center" style={{ marginTop: 28 }}>
                      There are no notes attached to this ticket
                    </p>
                  )}
                </Fragment>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <HexButton
              type="button"
              className="btn btn-orange"
              data-dismiss="modal"
            >
              Back
            </HexButton>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/SuperSupport/SuperTicketDetailModal.js